import React from 'react';
import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';

import { getThemeBadgeColor } from '../../../utility/badgeColors';
import {
  ClipContextTooltip,
  DARK_TOOLTIP_STYLE,
} from '../../common/ClipContextTooltip';

import type { BadgeColor } from '../../../utility/badgeColors';
import type { TooltipEntry } from '../../common/ClipContextTooltip';

function buildQuoteTooltipEntries(
  metadata: Record<string, any>,
): TooltipEntry[] {
  const entries: TooltipEntry[] = [];

  if (metadata.customPrompt) {
    entries.push({ label: 'Custom', value: String(metadata.customPrompt) });
  }
  if (metadata.theme) {
    entries.push({ label: 'Prompt', value: String(metadata.theme) });
  }

  return entries.filter(e => e.value);
}

type Props = {
  metadata: Record<string, any>;
  cardId: string;
};

export const QuoteThemeBadge: React.FC<Props> = ({ metadata, cardId }) => {
  const hasTheme = !!metadata.theme;
  const badgeLabel = hasTheme ? String(metadata.theme) : 'Custom Prompt';
  const badgeColor: BadgeColor | 'orange' = hasTheme
    ? getThemeBadgeColor(metadata.theme)
    : 'orange';
  const tooltipEntries = buildQuoteTooltipEntries(metadata);
  const tooltipId = `quote-theme-tooltip-${cardId}`;

  return (
    <>
      <ThemeTag
        $color={badgeColor}
        data-tooltip-id={tooltipId}
        data-tooltip-content="-"
        onClick={e => e.stopPropagation()}
      >
        {badgeLabel}
      </ThemeTag>
      {tooltipEntries.length > 0 && (
        <Tooltip
          id={tooltipId}
          style={DARK_TOOLTIP_STYLE}
          opacity={1}
          render={() => <ClipContextTooltip entries={tooltipEntries} />}
        />
      )}
    </>
  );
};

const ThemeTag = styled.div<{ $color?: string }>`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 999px;
  background-color: ${props => `var(--badge-${props.$color || 'blue'}-bg)`};
  color: ${props => `var(--badge-${props.$color || 'blue'}-text)`};
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  line-height: var(--leading-text-xs);
  white-space: nowrap;
  width: fit-content;
`;
